module.exports = __webpack_public_path__ + "static/media/diving_tiny.aa5ba53e.webp";